import { gql } from '@apollo/client';

export const getPostsQuery = gql`
  query getPostsQuery($where: ArticleWhereInput, $skip: Int, $take: Int, $orderBy: [ArticleOrderByInput!]) {
    articles(where: $where, skip: $skip, take: $take, orderBy: $orderBy) {
      id
      title
      shortDescription
      createdAt
      coverImage {
        ...BaseImageFields
      }
      parentArticle {
        id
      }
    }
  }
`;
